export enum UploadFileType {
  // 服务端管理上传文件
  TaskPreview = 'TASK_PREVIEW', //需求缩略图
  TaskAttachment = 'TASK_ATTACHMENT', //需求需求附件
  ReviewPreview = 'REVIEW_PREVIEW', //批注反馈的缩略图
  reviewAttachment = 'REVIEW_ATTACHMENT', //批注反馈的附件
  applicationAttachment = 'APPLICATION_ATTACHMENT', //竞标申请的附件
  VersionFile = 'VERSION_FILE', //版本文件（包括质检结果文件）
  VersionAttachment = 'VERSION_ATTACHMENT', //版本附件
  Private = 'PRIVATE', //上传到数源并且不公开
  Public = 'PUBLIC', //上传到数源并且公开
}
